var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.PanelOptions = new Class({
    Implements: [Options, Events],
    options: {
        template_url: "html/panel_options.html"
    },
    container: null,
    template: null,
    bound_methods: {},
    initialize: function (el, ops) {
        if (!el) {
            console.warn('OCS.Viewer.Classes.PanelOptions: No container passed!');
            return false;
        }
        if (el) {
            var obj = el.retrieve('panel_options');
            if (obj) {
                return obj;
            }
            this.container = el;
        }
        this.setOptions(ops);
        this.bound_methods.load_panel_options_html = this.load_panel_options_html.bind(this);
        this.bound_methods.toggle_container = this.toggle_container.bind(this);
        this.bound_methods.on_layer_visibility_click = this.on_layer_visibility_click.bind(this);
        this.bound_methods.on_layer_legend_visibility_click = this.on_layer_legend_visibility_click.bind(this);
        this.bound_methods.update_layer_visibility = this.update_layer_visibility.bind(this);
        this.bound_methods.update_legend_visibility = this.update_legend_visibility.bind(this);

        this.template = new OCS.Viewer.Classes.HtmlTemplateRequest({template_name: 'panel_options', url: OCS.Package.root + this.options.template_url});
        this.template.addEvent('success', this.bound_methods.load_panel_options_html);

        this.addEvent(OCS.Viewer.Config.events.LAYER_VISIBILITY_CHANGED, this.bound_methods.update_layer_visibility);
        this.addEvent(OCS.Viewer.Config.events.LAYER_LEGEND_VISIBILITY_CHANGED, this.bound_methods.update_legend_visibility);

        el.store('panel_options', this);
    },
    init_html_events: function () {
        // Apply the toggle panel options open and close button event
        this.container.getChildren('.panel_options_arrow').addEvent('click', this.bound_methods.toggle_container);

        // Apply layer visibility listeners
        this.container.getElements('span.layer_visibility_button').addEvent('click', this.bound_methods.on_layer_visibility_click);

        // Apply layer legend visibility listeners
        this.container.getElements('span.layer_legend_button').addEvent('click', this.bound_methods.on_layer_legend_visibility_click);

    },
    remove_html_events: function () {
        this.container.getChildren('.panel_options_arrow').removeEvent('click', this.bound_methods.toggle_container);
        this.container.getElements('span.layer_visibility_button').removeEvent('click', this.bound_methods.on_layer_visibility_click);
        this.container.getElements('span.layer_legend_button').removeEvent('click', this.bound_methods.on_layer_legend_visibility_click);
    },
    load_panel_options: function (layers) {
        var data = {
            layerGroups: []
        };
        Object.each(layers, function (layer_group, layer_group_id) {
            var layer_group_info = {
                group_id: layer_group_id,
                layer_cat_type: layer_group.get_layer_cat_type(),
                layer_name: layer_group.get_layer_name(),
                layer_short_name: layer_group.get_layer_short_name(),
                layer_type: layer_group.get_layer_type(),
                visibility: layer_group.get_layer_visibility_text()
            };
            if (!layer_group.is_static()) {
                var active_time;
                if (layer_group.get_active_timestamp_epoch) {
                    active_time = layer_group.get_active_timestamp_epoch();
                } else {
                    var map_obj = layer_group.get_map_datetime_obj();
                    active_time = map_obj.get_current_epoch_time();
                }
                var layerTime = moment(active_time);
                var mapTime = moment(active_time);
                var relTime = layerTime.from(mapTime);
                layer_group_info.relTime = {};
                layer_group_info.relTime.layer_time = relTime;

            }
            if (layer_group.has_legend) {
                layer_group_info.legend = {};
                layer_group_info.legend.legend_class = (layer_group.get_layer_legend_visibility()) ? "sprite-legend-selected" : "sprite-legend-unselected";
            }
            data.layerGroups.push(layer_group_info);

        });
        data.layerGroups.reverse();
        this.template.get_html(data);
    },
    load_panel_options_html: function (html) {
        this.remove_html_events();
        this.container.removeEvents();
        this.container.getChildren().each(function (el) {
            el.destroy();
        });
        Elements.from(html).inject(this.container);
        this.update_size();
        this.init_html_events();
    },
    update_size: function () {
        if (this.container) {
            var parent_el_dims = this.container.getParent().getCoordinates();
            var title_el_dims = this.container.getElements('.title')[0].getCoordinates();
            var options_el = this.container.getElements('.options')[0];
            var map_height = parent_el_dims.height,
                    map_options_height = title_el_dims.height,
                    map_controls_container_height = 52,
                    legend_info_container_height = 25,
                    legend_container_height = 10,
                    offset = 15;
            var options_max_height = map_height - map_options_height - map_controls_container_height - legend_info_container_height - legend_container_height - offset;
            options_el.setStyle('max-height', options_max_height);
        }
    },
    update_layer_visibility: function (input) {
        var group_id = input.group_id;
        var visible = input.condition;
        var visible_button = this.container.getElements('.layer_' + group_id + ' .layer_visibility_button');
        var legend_button = this.container.getElements('.layer_' + group_id + ' .layer_legend_button');
        var offset = this.container.getElements('.layer_' + group_id + ' .time_ago');
        if (visible) {
            visible_button.removeClass('off').addClass('on');
            offset.removeClass("hidden");
            legend_button.removeClass("hidden");
        } else {
            visible_button.removeClass('on').addClass('off');
            offset.addClass('hidden');
            legend_button.addClass('hidden');
        }
    },
    update_legend_visibility: function (input) {
        var group_id = input.group_id;
        var visible = input.condition;
        var legend = this.container.getElements('.layer_' + group_id + ' .layer_legend_button');
        if (visible) {
            legend.removeClass('sprite-legend-unselected').addClass('sprite-legend-selected');
        } else {
            legend.removeClass('sprite-legend-selected').addClass('sprite-legend-unselected');
        }

        if (visible) {
            legend.removeClass('sprite-legend-unselected').addClass('sprite-legend-selected');
        } else {
            legend.removeClass('sprite-legend-selected').addClass('sprite-legend-unselected');
        }

    },
    toggle_container: function (event) {
        if (this.container.hasClass('active')) {
            this.close();
        } else {
            this.open();
        }
    },
    open: function () {
        this.container.addClass('active');
        this.update_size();
        this.container.getChildren('.panel_options_container').addClass('active').removeClass('panel_options-out-animation').addClass('panel_options-in-animation');
    },
    close: function () {
        this.container.removeClass('active');
        this.container.getChildren('.panel_options_container').removeClass('active').removeClass('panel_options-in-animation').addClass('panel_options-out-animation');
    },
    frame_changed: function (layer_groups, time_update) {
        var ts = time_update.get_current_epoch_time();
        Object.each(layer_groups, function (layer_group, idx) {
            var layerTime;
            if (layer_group.get_active_timestamp_epoch) {
                layerTime = moment(layer_group.get_active_timestamp_epoch());
            } else if (layer_group.get_map_datetime_obj) {
                var map_obj = layer_group.get_map_datetime_obj();
                layerTime = moment(map_obj.get_current_epoch_time());
            } else {
                layerTime = moment(ts);
            }
            var mapTime = moment(ts);
            var relTime = (layerTime.isValid() && mapTime.isValid()) ? layerTime.from(mapTime) : '--';
            relTime = (relTime.indexOf('in') === 0) ? '-0m' : relTime;
            this.container.getElements('.layer_' + idx + ' .time_ago').set('html', relTime);
        }.bind(this));

    },
    /*
     * 
     * Event listeners
     *  
     */
    on_layer_visibility_click: function (event) {
        var group_id = event.target.getParent().getProperty('data-group_id');
        this.fireEvent(OCS.Viewer.Config.events.TOGGLE_LAYER_VISIBILITY, {id: group_id, event: event});
    },
    on_layer_legend_visibility_click: function (event) {
        var group_id = event.target.getParent().getProperty('data-group_id');
        this.fireEvent(OCS.Viewer.Config.events.TOGGLE_LAYER_LEGEND_VISIBILITY, {id: group_id, event: event});
    },
    destroy: function () {
        this.template.removeEvent('success', this.bound_methods.load_panel_options_html);
        this.template.destroy();
        this.template = null;
        this.remove_html_events();
        this.container.removeEvents();
        this.container.store('panel_options', null);
        this.container.destroy();
        this.container = null;
    }

});